import type { MediaType, PreviewMediaType } from './media';

export type GenerationErrorType =
  | 'content_moderation'
  | 'timeout'
  | 'rate_limited'
  | 'server_error'
  | 'network_error'
  | 'no_result'
  | 'general';

export interface WebhookContext {
  flowId: string;
  presetTitle: string;
  presetType?: PreviewMediaType;
  webhookParams: Record<string, unknown>;
  presetSlug?: string;
  categorySlug?: string;
}

export interface ContentFile {
  url: string;
  uuid: string;
  name: string;
  type?: MediaType;
  isLoading?: boolean;
  generationStartTime?: number;
  presetType?: PreviewMediaType;
  preview?: {
    url?: string;
    width?: number;
    height?: number;
  };
  error?: string;
  errorType?: GenerationErrorType;
  webhookContext?: WebhookContext;
}

export enum Screen {
  Library = 'library',
  Create = 'create',
  Loading = 'loading',
  Files = 'files',
}
